export const escapeNewlinesAndTabs = (value: string): string =>
  (value || '').replace(/[\r\n\t]/g, ' ')
